import { observable, action, toJS } from "mobx";
import { WeaLocaleProvider, WeaTools } from "ecCom";
import WeaForm from "../../wea-form";
import { message } from "antd";
import * as API from "../apis/systemSetApi.js";
const getLabel = WeaLocaleProvider.getLabel;
const { getKey } = WeaTools;
export default class SystemSet {
  @observable
  loading = true;
  @observable
  oDloading = true;
  @observable
  wDloading = true;
  @observable
  openVal = "0";
  @observable
  openRightVal = "0";
  @observable
  rightDisabled = false;

  @observable
  dataSource = [];
  @observable
  moduleOptions = [];
  @observable
  moduleValue = "";
  @observable
  typeid = "0";
  @observable
  userid = 0;
  @observable
  dialogtitle = "";
  @observable
  otherDetailVisiable = false;

  @observable
  replaceData = [];
  @observable
  workflowDetailVisiable = false;
  @observable
  condition = [];
  @observable
  detailParams = {};
  @observable
  workflowCondition = [];
  @observable
  oDForm = new WeaForm();
  @observable
  workflowForm = new WeaForm();
  @observable
  syncPathVisiable = false;
  @observable
  syncPathOptions = [];
  @observable
  syncPathValue = "";
  @observable
  currentSyncKey = "";

  @action
  getModuleOptions = params => {
    API.getModuleOptions(params).then(res => {
      if (res.status) {
        this.moduleOptions = res.options;
      }
    });
  };

  @action
  getSystemSetTable = params => {
    this.loading = true;
    API.getSystemSetTable({ moduleid: this.moduleValue, ...params }).then(
      res => {
        if (res.api_status && res.ret) {
          this.userid = res.userid;
          this.dataSource = res.datas;
        } else {
          if (res.api_status) {
            message.error(res.message);
          } else {
            message.error(res.api_errormsg);
          }
        }
        this.loading = false;
      },
      error => {
        message.warning(error.message);
      }
    );
  };

  @action
  saveConfig2DB = callback => {
    this.loading = true;
    let dataSource = JSON.stringify(this.dataSource);
    let params = {
      userid: this.userid,
      module: this.moduleValue,
      datas: dataSource
    };
    API.saveUserConfig(params).then(
      res => {
        if (res.api_status && res.ret) {
          this.getSystemSetTable();
          message.success(getLabel(506152, "保存成功"));
          if (typeof callback === "function") {
            callback();
          }
        } else {
          if (res.api_status) {
            message.error(res.message);
          } else {
            message.error(res.api_errormsg);
          }
        }
        this.loading = false;
      },
      error => {
        message.warning(error.message);
      }
    );
  };

  @action
  getDetailCondition = params => {
    this.oDloading = true;
    this.detailParams = { userid: this.userid, ...params };
    API.getDetailCondition(this.detailParams).then(res => {
      if (res.api_status) {
        this.oDForm = new WeaForm();
        this.condition = res.conditions;
        this.oDForm.setCondition(this.condition);
        this.setOtherDetailVisiable(true);
      }
      this.oDloading = false;
    });
  };

  @action
  saveDetail = () => {
    const formParams = this.oDForm.getFormParams();
    let params = {
      ...this.detailParams,
      userid: this.userid,
      datas: JSON.stringify(formParams)
    };
    this.oDloading = true;
    API.saveDetail(params).then(res => {
      if (res.api_status) {
        this.setOtherDetailVisiable(false);
        message.success(getLabel(506152, "保存成功"));
      }
      this.oDloading = false;
    });
  };

  @action
  saveWorkflowDetail = () => {
    this.wDloading = true;
    const include = toJS(this.workflowCondition)[0].value;
    const formParams = this.workflowForm.getFormParams();
    const params = {
      ...this.detailParams,
      userid: this.userid,
      datas: JSON.stringify(formParams),
      include: include
    };
    API.saveWorkflowDetail(params).then(res => {
      if (res.api_status) {
        this.setWorkflowDetailVisiable(false);
        message.success(getLabel(506152, "保存成功"));
      }
      this.wDloading = false;
    });
  };

  @action
  getWorkflowCondition = params => {
    this.wDloading = true;
    this.detailParams = { userid: this.userid, ...params };
    API.getWorkflowDetailCondition(this.detailParams).then(res => {
      if (res.api_status) {
        this.workflowForm = new WeaForm();
        this.workflowCondition = res.conditions;
        this.workflowForm.setCondition(this.workflowCondition);
        this.setWorkflowDetailVisiable(true);
      }
      this.wDloading = false;
    });
  };

  @action
  showSyncWorkflowPath = params => {
    this.syncPathOptions = [];
    this.setSyncPathVisiable(true);
    toJS(this.workflowCondition) &&
      toJS(this.workflowCondition).forEach((c, index) => {
        c.syncOptions.forEach(fields => {
          if (fields.key != params) {
            this.syncPathOptions.push(fields);
            this.syncPathValue += fields.key + ",";
          }
        });
      });
    this.currentSyncKey = params;
  };

  @action
  changeWorkflowCondition(params) {
    let conditon = [];
    conditon =
      toJS(this.workflowCondition) &&
      toJS(this.workflowCondition).map((c, index) => {
        c.items.map(fields => {
          for (let key in params) {
            if (getKey(fields) == key) {
              let type = params[key].value[0];
              fields.options &&
                fields.options.map(option => {
                  if (option.key == type) {
                    option.selected = true;
                  } else {
                    option.selected = false;
                  }
                });
              if (type != 0) {
                if (params[key].value[1]) {
                  fields.selectLinkageDatas[
                    type
                  ].browserConditionParam.replaceDatas =
                    params[key].value[1][2];
                } else {
                  fields.selectLinkageDatas[
                    type
                  ].browserConditionParam.replaceDatas = params[key].value[1];
                }
              }
            }
          }
          return fields;
        });
        return c;
      });
    this.workflowCondition = conditon;
  }

  @action
  sureSyncWorkflowPath = () => {
    const syncKey = this.currentSyncKey;
    const syncPath = this.syncPathValue;

    let selectLinkageDatas = {};
    let options = [];
    toJS(this.workflowCondition) &&
      toJS(this.workflowCondition).map((c, index) => {
        c.items.map(fields => {
          if (getKey(fields) == syncKey) {
            selectLinkageDatas = fields.selectLinkageDatas;
            options = fields.options;
          }
        });
      });
    let condition = [];
    condition =
      toJS(this.workflowCondition) &&
      toJS(this.workflowCondition).map((c, index) => {
        c.items.map(fields => {
          if (syncPath.indexOf(getKey(fields)) > -1) {
            let domkey = fields.selectLinkageDatas[1].domkey;
            let data = JSON.stringify(selectLinkageDatas),
              selectLink = JSON.parse(data);
            selectLink[1].domkey = domkey;
            selectLink[2].domkey = domkey;
            fields.selectLinkageDatas = selectLink;
            fields.options = options;
          }
          return fields;
        });
        return c;
      });

    this.workflowCondition = condition;
    this.workflowForm = new WeaForm();
    this.workflowForm.initFormFields(this.workflowCondition);
    this.setSyncPathVisiable(false);
  };

  @action
  changeModuleValue = val => {
    this.moduleValue = val;
    this.getSystemSetTable();
  };

  @action
  setOpenVal = val => {
    this.openVal = val;
  };

  @action
  setOpenRightVal = val => {
    this.openRightVal = val;
  };

  @action
  setRightDisabled = diaplay => {
    this.rightDisabled = diaplay;
  };

  @action
  changeDataSource = params => {
    this.dataSource = params;
  };
  @action
  setTypeid = typeid => {
    this.typeid = typeid;
  };
  @action
  setWorkflowDetailVisiable = param => {
    this.workflowDetailVisiable = param;
  };
  @action
  setOtherDetailVisiable = param => {
    this.otherDetailVisiable = param;
  };
  @action
  setCondition = params => {
    this.condition = params;
  };

  @action
  changeConditionValue = params => {
    this.workflowCondition[0].value = params;
  };

  setSyncPathVisiable = params => {
    this.syncPathVisiable = params;
  };

  setSyncPathValue = params => {
    this.syncPathValue = params;
  };

  @action
  setDialogtitle = params => {
    this.dialogtitle = params;
  };
}



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/stores/systemSet.js